import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MaterialModule } from "../material.module";

import { CvaAuthPermCheckDirective } from './directives/cva-auth-perm-check/cva-auth-perm-check.directive';
import { FormTemplateComponent } from "./form-template/form-template.component";
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { CvaTrimSpacesDirective } from './directives/cva-trim-spaces/cva-trim-spaces.directive';

@NgModule({
  declarations: [
    FormTemplateComponent,
    CvaAuthPermCheckDirective,
    ConfirmationDialogComponent,
    CvaTrimSpacesDirective
  ],
  imports: [
    CommonModule,
    MaterialModule
  ],
  exports:[
    FormTemplateComponent,
    CvaAuthPermCheckDirective,
    ConfirmationDialogComponent,
    CvaTrimSpacesDirective
  ]
})
export class SharedModule { }
